<script>
    import LocationCardList from '../components/LocationCardList.svelte';
    import Loading from '../components/Loading.svelte';
    import { organizationSets } from '../stores';

    let showSets = false;

    organizationSets.subscribe((v) => {
        if (v === null || v.length < 1) {
            return;
        }
        showSets = true;
    });
</script>

{#if showSets}
    <LocationCardList />
{:else}
    <Loading />
{/if}
